"use client"

import { cn } from "@/lib/utils"

interface LogoProps {
  size?: "sm" | "md" | "lg"
  showText?: boolean
  className?: string
  /** Product label to render next to the wordmark, e.g. "Flow". */
  productLabel?: string
}

// The Windmill wordmark + footer wordmark are dropped into public/ by
// audra-devops/scripts/sync-design-tokens.sh; identical across the suite.
const WINDMILL_LOGO = "/windmill-logo.svg"
const WINDMILL_LOGO_DARK = "/windmill-logo-dark.svg"

export function Logo({ size = "md", showText = true, className, productLabel = "Flow" }: LogoProps) {
  const heightClasses = {
    sm: "h-5",
    md: "h-6",
    lg: "h-7",
  }

  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <img
        src={WINDMILL_LOGO}
        alt="Windmill"
        className={cn("w-auto hidden dark:block", heightClasses[size])}
      />
      <img
        src={WINDMILL_LOGO_DARK}
        alt="Windmill"
        className={cn("w-auto block dark:hidden", heightClasses[size])}
      />
      {showText ? (
        <span className="text-xs font-medium uppercase tracking-wider text-wm-gray-100/70">
          {productLabel}
        </span>
      ) : null}
    </div>
  )
}

// Icon-only version for sidebar collapses etc.
export function LogoIcon({ size = "md", className }: Omit<LogoProps, "showText" | "productLabel">) {
  const heightClasses = {
    sm: "h-6",
    md: "h-7",
    lg: "h-8",
  }
  return (
    <img
      src={WINDMILL_LOGO}
      alt="Windmill"
      className={cn("w-auto", heightClasses[size], className)}
    />
  )
}
